export default "__VITE_ASSET__Cddc$74a__"